import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Transition as _Transition, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-workspace__header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "page-workspace__logo-image" }, null, -1)
const _hoisted_3 = { class: "page-workspace__tabs" }
const _hoisted_4 = { class: "page-workspace__buttons" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("POT")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LicenseAgreement = _resolveComponent("LicenseAgreement")!
  const _component_NWorkspaceTabs = _resolveComponent("NWorkspaceTabs")!
  const _component_ChangeLanguage = _resolveComponent("ChangeLanguage")!
  const _component_NButton = _resolveComponent("NButton")!
  const _component_NotificationHeader = _resolveComponent("NotificationHeader")!
  const _component_UserMenu = _resolveComponent("UserMenu")!
  const _component_MultisidebarContent = _resolveComponent("MultisidebarContent")!
  const _component_NLaunchpad = _resolveComponent("NLaunchpad")!
  const _component_MultisidebarMenu = _resolveComponent("MultisidebarMenu")!
  const _component_DataModal = _resolveComponent("DataModal")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(['page-workspace', { 'page-workspace_multisidebar-active': _ctx.sidebarModule.active }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "page-workspace__logo",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLogoClick && _ctx.handleLogoClick(...args)))
        }, [
          _hoisted_2,
          (_ctx.showLicense)
            ? (_openBlock(), _createBlock(_component_LicenseAgreement, {
                key: 0,
                onProceed: _ctx.proceedHandler
              }, null, 8, ["onProceed"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_NWorkspaceTabs, {
            ref: "tab",
            modelValue: _ctx.workspaceModule.current,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.workspaceModule.current) = $event)),
            "min-width": 56,
            "max-width": 300,
            items: _ctx.workspaceModule.computedTabItems,
            "new-label": _ctx.$t('common.new_tool'),
            onToggleLaunchpad: _ctx.toggleLaunchpad,
            onAfterLeft: _ctx.updateLaunchpadLeft,
            onContextmenu: _ctx.handleContextClick,
            onRemoveTab: _ctx.removeTab,
            onSwapTabs: _ctx.workspaceModule.swapTabs
          }, null, 8, ["modelValue", "items", "new-label", "onToggleLaunchpad", "onAfterLeft", "onContextmenu", "onRemoveTab", "onSwapTabs"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_ChangeLanguage),
          (_ctx.applicationModule.settings.debug)
            ? (_openBlock(), _createBlock(_component_NButton, {
                key: 0,
                type: "text",
                onClick: _ctx.exportPot
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_NButton, {
            "icon-size": "16",
            type: "text",
            icon: "change-theme",
            onClick: _ctx.changeTheme
          }, null, 8, ["onClick"]),
          _createVNode(_component_NotificationHeader, {
            "is-playing": _ctx.alertModule.isPlaying,
            "mute-state": _ctx.alertModule.isMuting,
            onAcknowledgeAction: _ctx.acknowledgeAll,
            onShowEventsAction: _ctx.navigateToEventsPage,
            onToggleMute: _cache[2] || (_cache[2] = ($event: any) => (_ctx.alertModule.toggleMute()))
          }, null, 8, ["is-playing", "mute-state", "onAcknowledgeAction", "onShowEventsAction"]),
          _createVNode(_component_UserMenu)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(['page-workspace__content', { 'page-workspace_shadow': _ctx.isLauncherPage, 'page-workspace__content-decreased': _ctx.contentDecreased }])
      }, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _hoisted_6
        ])
      ], 2),
      _createVNode(_component_MultisidebarContent),
      _createVNode(_Transition, { name: "slide" }, {
        default: _withCtx(() => [
          (_ctx.launchpad)
            ? _withDirectives((_openBlock(), _createBlock(_component_NLaunchpad, {
                key: 0,
                class: "workspace-launchpad",
                onOpenNewTab: _ctx.openNewTab,
                items: _ctx.formattedItems,
                arrowLeft: _ctx.launchpadPos.arrowLeft,
                style: _normalizeStyle({ left: _ctx.launchpadPos.containerLeft + 'px' })
              }, null, 8, ["onOpenNewTab", "items", "arrowLeft", "style"])), [
                [_directive_click_outside, _ctx.closeLauncher]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 2),
    _createVNode(_component_MultisidebarMenu),
    _createVNode(_component_DataModal)
  ], 64))
}